exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body{margin:0;padding:0}#app{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;height:100vh;background:url(" + require("./assets/pic.jpg") + ") no-repeat;background-size:100%}#top{text-align:center;color:#fff}#main{width:100%;height:80vh}#main,#show{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}#show{width:60%;height:60%;background:rgba(80,211,255,.32)}#bottom{width:100%;text-align:center}#bottom a{color:red;text-decoration:none}#bottom a:hover{font-size:20px;font-weight:900}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34d3cdfe","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 136
// module chunks = 1